// extracted by mini-css-extract-plugin
module.exports = {"reference":"actionIcon_reference__X62-9","content":"actionIcon_content__C-fwD","button":"actionIcon_button__2tvuK"};